import { useState } from 'react'
import LeftHome from './components/LeftHome'
import RightHome from './components/RightHome'
import { Helmet } from "react-helmet";
import './Home.scss'
import { constUrlBase } from 'constants/api';

export default function Home() {
  const [tabActive, setTabActive] = useState('vn')
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{constUrlBase.phan_tich_thi_truong.title}</title>
        <meta name="description" content={constUrlBase.phan_tich_thi_truong.description} />
      </Helmet>
      <div className='ASLIPWKUmL'>
        <div onClick={() => setTabActive('vn')} className={`rPKqPbujSB ${tabActive === 'vn' ? 'febjeYLQzZ' : ''}`}>Thị trường Việt Nam</div>
        <div onClick={() => setTabActive('tg')} className={`rPKqPbujSB ${tabActive === 'tg' ? 'febjeYLQzZ' : ''}`}>Thị trường Thế giới</div>
      </div>
      <div className='pimsksrgep'>
        <div className={`ujmlenhaxv bWcbYgkhTZ ${tabActive === 'tg' ? 'wCRbfMHWXT' : ''}`}>
          <LeftHome />
        </div>
        <div className={`pvrcfcmomu bWcbYgkhTZ ${tabActive === 'vn' ? 'wCRbfMHWXT' : ''}`}>
          <RightHome />
        </div>
      </div>
    </>
  )
}